import { NextPageWithLayout } from '@/app/types'
import PolicyViewRootPage from '@/components/pages/document/ui/PolicyViewRootPage'
import { LayoutSimpleWithHeader } from '@/layouts/simple-with-header'

const PolicyViewPage: NextPageWithLayout = () => {
  return <PolicyViewRootPage />
}

PolicyViewPage.getLayout = page => {
  return (
    <LayoutSimpleWithHeader mainClass="grow">{page}</LayoutSimpleWithHeader>
  )
}

export default PolicyViewPage
